
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import './pendo-divider.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'popper.js';
import 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import { P as PickerPopover } from './picker-popover-mixin.js';
import 'lodash/debounce';
import './emitter-mixin.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import PendoMultiselectProps from './pendo-multiselect-props.js';
import PendoMultiselectCore from './pendo-multiselect-core.js';
import PendoMultiselectInput from './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import PendoMultiselectOptions from './pendo-multiselect-options.js';
import PendoMultiselectTrigger from './pendo-multiselect-trigger.js';
import PendoMultiselectValue from './pendo-multiselect-value.js';

var script = {
  name: 'PendoMultiselect',
  components: {
    PendoMultiselectInput,
    PendoMultiselectCore,
    PendoMultiselectOptions,
    PendoMultiselectTrigger,
    PendoMultiselectValue,
    PickerPopover
  },
  mixins: [PendoMultiselectProps],
  inheritAttrs: false,
  methods: {
    toggleMenu() {
      return this.$refs.core.toggleMenu();
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-multiselect-core', _vm._g(_vm._b({
    ref: "core",
    attrs: {
      "internal-search": _vm.internalSearch && !_vm.groupSelect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var activate = ref.activate;
        var allOptionsSelected = ref.allOptionsSelected;
        var allSelectedText = ref.allSelectedText;
        var appendToBody = ref.appendToBody;
        var computedMenuWidth = ref.computedMenuWidth;
        var computedPlaceholder = ref.computedPlaceholder;
        var deactivate = ref.deactivate;
        var filteredOptions = ref.filteredOptions;
        var flattenedOptions = ref.flattenedOptions;
        var formatOptionLabel = ref.formatOptionLabel;
        var getOptionLabel = ref.getOptionLabel;
        var groupDividers = ref.groupDividers;
        var groupLabelKey = ref.groupLabelKey;
        var groupOptionsKey = ref.groupOptionsKey;
        var groupSelect = ref.groupSelect;
        var handleBlur = ref.handleBlur;
        var handleClickOutside = ref.handleClickOutside;
        var handleFocus = ref.handleFocus;
        var handleHide = ref.handleHide;
        var handleKeydown = ref.handleKeydown;
        var handleTriggerClick = ref.handleTriggerClick;
        var hasGroups = ref.hasGroups;
        var hideSelectedOptions = ref.hideSelectedOptions;
        var id = ref.id;
        var inputValue = ref.inputValue;
        var invalid = ref.invalid;
        var isDisabled = ref.isDisabled;
        var isEntireGroupSelected = ref.isEntireGroupSelected;
        var isFocused = ref.isFocused;
        var isFullWidth = ref.isFullWidth;
        var isOpen = ref.isOpen;
        var isOptionSelected = ref.isOptionSelected;
        var isPlaceholderVisible = ref.isPlaceholderVisible;
        var isSearchable = ref.isSearchable;
        var isSearchIconVisible = ref.isSearchIconVisible;
        var isSelectedLabelVisible = ref.isSelectedLabelVisible;
        var labels = ref.labels;
        var limit = ref.limit;
        var limitText = ref.limitText;
        var max = ref.max;
        var maxMenuHeight = ref.maxMenuHeight;
        var maxMenuWidth = ref.maxMenuWidth;
        var maxTriggerWidth = ref.maxTriggerWidth;
        var minMenuWidth = ref.minMenuWidth;
        var minTriggerWidth = ref.minTriggerWidth;
        var model = ref.model;
        var multiple = ref.multiple;
        var noResultsText = ref.noResultsText;
        var optionHeight = ref.optionHeight;
        var options = ref.options;
        var placeholder = ref.placeholder;
        var pointer = ref.pointer;
        var pointerSet = ref.pointerSet;
        var popperOptions = ref.popperOptions;
        var popperPlacement = ref.popperPlacement;
        var removeSelection = ref.removeSelection;
        var select = ref.select;
        var selectedLabel = ref.selectedLabel;
        var selectedValue = ref.selectedValue;
        var selectGroup = ref.selectGroup;
        var shouldAnimateSearchEnterExit = ref.shouldAnimateSearchEnterExit;
        var shouldScrollToFocusedOption = ref.shouldScrollToFocusedOption;
        var showMaxElements = ref.showMaxElements;
        var showNoResults = ref.showNoResults;
        var showPointer = ref.showPointer;
        var triggerWidth = ref.triggerWidth;
        var updateInputValue = ref.updateInputValue;
        var valueKey = ref.valueKey;
        var visibleSelectedValues = ref.visibleSelectedValues;
        return _c('div', {
          staticClass: "pendo-multiselect",
          class: {
            'is-active': isFocused || isOpen,
            'is-open': isOpen,
            'is-disabled': isDisabled,
            'is-error': invalid,
            'pendo-multiselect--inline-label': !!labels.left || !!labels.right,
            'pendo-multiselect--full-width': isFullWidth,
            'pendo-multiselect--searchable': isSearchable
          }
        }, [labels.top || labels.left || !!_vm.$slots.topLabel ? _c('div', {
          staticClass: "pendo-multiselect__label pendo-multiselect__label--top"
        }, [_vm._t("topLabel", [_vm._v("\n                " + _vm._s(labels.top || labels.left) + "\n            ")])], 2) : _vm._e(), _vm._v(" "), _c('picker-popover', {
          attrs: {
            "is-open": isOpen,
            "append-to-body": appendToBody,
            "popper-options": popperOptions,
            "min-width": computedMenuWidth,
            "max-width": _vm.$props.maxMenuWidth,
            "max-height": _vm.$props.maxMenuHeight,
            "full-width": isFullWidth
          },
          on: {
            "click-outside": handleClickOutside,
            "hide": handleHide
          },
          scopedSlots: _vm._u([{
            key: "popper",
            fn: function () {
              return [_vm.$slots.header || _vm.$scopedSlots.header ? _c('div', {
                staticClass: "pendo-multiselect__header"
              }, [_vm._t("header", null, null, {
                model: model,
                removeSelection: removeSelection,
                select: select,
                toggleMenu: _vm.toggleMenu,
                updateInputValue: updateInputValue
              })], 2) : _vm._e(), _vm._v(" "), _vm._t("options", [_c('pendo-multiselect-options', _vm._b({
                ref: "list",
                scopedSlots: _vm._u([{
                  key: "_beforeList",
                  fn: function (props) {
                    return [_vm._t("beforeList", null, null, props)];
                  }
                }, {
                  key: "_optionGroup",
                  fn: function (props) {
                    return [_vm._t("optionGroup", null, null, props)];
                  }
                }, {
                  key: "_option",
                  fn: function (props) {
                    return [_vm._t("option", null, null, props)];
                  }
                }, {
                  key: "_afterList",
                  fn: function (props) {
                    return [_vm._t("afterList", null, null, props)];
                  }
                }, {
                  key: "_maxElements",
                  fn: function () {
                    return [_vm._t("maxElements")];
                  },
                  proxy: true
                }, {
                  key: "_noResult",
                  fn: function () {
                    return [_vm._t("noResult")];
                  },
                  proxy: true
                }, {
                  key: "_noData",
                  fn: function () {
                    return [_vm._t("noData")];
                  },
                  proxy: true
                }, {
                  key: "_allSelected",
                  fn: function () {
                    return [_vm._t("allSelected")];
                  },
                  proxy: true
                }], null, true)
              }, 'pendo-multiselect-options', {
                activate: activate,
                allOptionsSelected: allOptionsSelected,
                allSelectedText: allSelectedText,
                computedMenuWidth: computedMenuWidth,
                deactivate: deactivate,
                disabled: isDisabled,
                filteredOptions: filteredOptions,
                flattenedOptions: flattenedOptions,
                formatOptionLabel: formatOptionLabel,
                getOptionLabel: getOptionLabel,
                groupDividers: groupDividers,
                groupLabelKey: groupLabelKey,
                groupOptionsKey: groupOptionsKey,
                groupSelect: groupSelect,
                handleKeydown: handleKeydown,
                hasGroups: hasGroups,
                hideSelectedOptions: hideSelectedOptions,
                id: id,
                inputValue: inputValue,
                isEntireGroupSelected: isEntireGroupSelected,
                isFullWidth: isFullWidth,
                isOpen: isOpen,
                isOptionSelected: isOptionSelected,
                isPlaceholderVisible: isPlaceholderVisible,
                isSelectedLabelVisible: isSelectedLabelVisible,
                labelKey: _vm.labelKey,
                limit: limit,
                limitText: limitText,
                loading: _vm.loading,
                max: max,
                maxMenuHeight: maxMenuHeight,
                maxMenuWidth: maxMenuWidth,
                minMenuWidth: minMenuWidth,
                model: model,
                multiple: multiple,
                noResultsText: noResultsText,
                optionHeight: optionHeight,
                options: options,
                placeholder: placeholder,
                pointer: pointer,
                pointerSet: pointerSet,
                removeSelection: removeSelection,
                select: select,
                selectedLabel: selectedLabel,
                selectedValue: selectedValue,
                selectGroup: selectGroup,
                shouldScrollToFocusedOption: shouldScrollToFocusedOption,
                showMaxElements: showMaxElements,
                showNoResults: showNoResults,
                showPointer: showPointer,
                toggleMenu: _vm.toggleMenu,
                updateInputValue: updateInputValue,
                valueKey: valueKey,
                visibleSelectedValues: visibleSelectedValues
              }, false))], {
                "isOpen": isOpen,
                "value": model,
                "filteredOptions": filteredOptions,
                "flattenedOptions": flattenedOptions,
                "select": select
              }, _vm.$attrs), _vm._v(" "), _vm.$slots.footer || _vm.$scopedSlots.footer ? _c('div', {
                staticClass: "pendo-multiselect__footer"
              }, [_vm._t("footer", null, {
                "toggleMenu": _vm.toggleMenu
              })], 2) : _vm._e()];
            },
            proxy: true
          }], null, true)
        }, [_vm._t("trigger", [_c('pendo-multiselect-trigger', _vm._b({
          on: {
            "blur": handleBlur,
            "focus": handleFocus,
            "click": handleTriggerClick,
            "up": function ($event) {
              return handleKeydown('up');
            },
            "down": function ($event) {
              return handleKeydown('down');
            },
            "delete": function ($event) {
              return handleKeydown('delete');
            },
            "enter": function ($event) {
              return handleKeydown('enter', $event);
            },
            "space": function ($event) {
              return handleKeydown('space', $event);
            },
            "tab": function ($event) {
              return handleKeydown('tab', $event);
            },
            "esc": deactivate
          },
          scopedSlots: _vm._u([{
            key: "suffix",
            fn: function (props) {
              return [_vm._t("suffix", null, null, props)];
            }
          }], null, true)
        }, 'pendo-multiselect-trigger', {
          activate: activate,
          deactivate: deactivate,
          disabled: isDisabled,
          handleBlur: handleBlur,
          handleFocus: handleFocus,
          handleKeydown: handleKeydown,
          id: id,
          inputValue: inputValue,
          invalid: invalid,
          isFocused: isFocused,
          isFullWidth: isFullWidth,
          isOpen: isOpen,
          isSearchable: isSearchable,
          loading: _vm.loading,
          maxTriggerWidth: maxTriggerWidth,
          minTriggerWidth: minTriggerWidth,
          placeholder: placeholder,
          toggleMenu: _vm.toggleMenu,
          triggerSize: _vm.triggerSize
        }, false), [_c('pendo-multiselect-value', _vm._b({
          class: {
            'is-disabled': isDisabled
          },
          scopedSlots: _vm._u([{
            key: "control",
            fn: function () {
              return [isSearchable ? _vm._t("control", [_c('pendo-multiselect-input', _vm._b({
                on: {
                  "up": function ($event) {
                    return handleKeydown('up');
                  },
                  "down": function ($event) {
                    return handleKeydown('down');
                  },
                  "delete": function ($event) {
                    return handleKeydown('delete');
                  },
                  "enter": function ($event) {
                    return handleKeydown('enter', $event);
                  },
                  "space": function ($event) {
                    return handleKeydown('space', $event);
                  },
                  "tab": function ($event) {
                    return handleKeydown('tab', $event);
                  },
                  "esc": deactivate
                }
              }, 'pendo-multiselect-input', {
                activate: activate,
                computedPlaceholder: computedPlaceholder,
                deactivate: deactivate,
                disabled: isDisabled,
                id: id,
                inputValue: inputValue,
                isFullWidth: isFullWidth,
                isOpen: isOpen,
                isSearchable: isSearchable,
                isSearchIconVisible: isSearchIconVisible,
                minTriggerWidth: minTriggerWidth,
                multiple: multiple,
                placeholder: placeholder,
                shouldAnimateSearchEnterExit: !!_vm.$scopedSlots.selectedLabel || !!_vm.$scopedSlots.placeholder ? false : shouldAnimateSearchEnterExit,
                taggable: _vm.taggable,
                triggerSize: _vm.triggerSize,
                triggerWidth: triggerWidth,
                updateInputValue: updateInputValue
              }, false))], null, {
                activate: activate,
                computedPlaceholder: computedPlaceholder,
                deactivate: deactivate,
                disabled: isDisabled,
                handleKeydown: handleKeydown,
                id: id,
                inputValue: inputValue,
                isFullWidth: isFullWidth,
                isOpen: isOpen,
                isSearchable: isSearchable,
                isSearchIconVisible: isSearchIconVisible,
                minTriggerWidth: minTriggerWidth,
                multiple: multiple,
                placeholder: placeholder,
                shouldAnimateSearchEnterExit: !!_vm.$scopedSlots.selectedLabel || !!_vm.$scopedSlots.placeholder ? false : shouldAnimateSearchEnterExit,
                taggable: _vm.taggable,
                triggerSize: _vm.triggerSize,
                triggerWidth: triggerWidth,
                updateInputValue: updateInputValue
              }) : _vm._e()];
            },
            proxy: true
          }, {
            key: "tag",
            fn: function (props) {
              return [_vm._t("tag", null, null, props)];
            }
          }, {
            key: "selectedLabel",
            fn: function (props) {
              return [_vm._t("selectedLabel", null, null, props)];
            }
          }, {
            key: "placeholder",
            fn: function (props) {
              return [_vm._t("placeholder", null, null, props)];
            }
          }], null, true)
        }, 'pendo-multiselect-value', {
          getOptionLabel: getOptionLabel,
          inputValue: inputValue,
          isOpen: isOpen,
          isPlaceholderVisible: isPlaceholderVisible,
          isSearchable: isSearchable,
          isSelectedLabelVisible: isSelectedLabelVisible,
          limit: limit,
          limitText: limitText,
          loading: _vm.loading,
          model: model,
          multiple: multiple,
          placeholder: placeholder,
          removeSelection: removeSelection,
          selectedLabel: selectedLabel,
          selectedValue: selectedValue,
          shouldAnimateSearchEnterExit: !!_vm.$scopedSlots.selectedLabel || !!_vm.$scopedSlots.placeholder ? false : shouldAnimateSearchEnterExit,
          toggleMenu: _vm.toggleMenu,
          visibleSelectedValues: visibleSelectedValues
        }, false))], 1)], null, {
          deactivate: deactivate,
          disabled: isDisabled,
          handleBlur: handleBlur,
          handleFocus: handleFocus,
          handleKeydown: handleKeydown,
          isFocused: isFocused,
          isOpen: isOpen,
          isSearchable: isSearchable,
          toggleMenu: _vm.toggleMenu,
          triggerSize: _vm.triggerSize
        })], 2), _vm._v(" "), labels.bottom || labels.right || !!_vm.$slots.bottomLabel ? _c('div', {
          staticClass: "pendo-multiselect__label pendo-multiselect__label--bottom"
        }, [_vm._t("bottomLabel", [_vm._v("\n                " + _vm._s(labels.bottom || labels.right) + "\n            ")])], 2) : _vm._e()], 1);
      }
    }], null, true)
  }, 'pendo-multiselect-core', _vm.$props, false), _vm.$listeners));
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-multiselect.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoMultiselect = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoMultiselect;
